import a from "axios";
var h = "http://tea-shop-merchant-be-biz".replace(/\/+$/, ""), i = class {
  constructor(r, e = h, t = a) {
    if (this.basePath = e, this.axios = t, r) {
      var s;
      this.configuration = r, this.basePath = (s = r.basePath) !== null && s !== void 0 ? s : e;
    }
  }
}, l = class extends Error {
  constructor(r, e) {
    super(e), this.field = r, this.name = "RequiredError";
  }
}, p = {};
export {
  h as BASE_PATH,
  i as BaseAPI,
  l as RequiredError,
  p as operationServerMap
};

//# sourceMappingURL=base.js.map